export default __webpack_public_path__ + "static/benifitImage3-c88a83016821d6426c3ca40315edf307.webp";